import { Injectable } from '@angular/core';

const TOKEN_KEY = 'CesarAuthToken';

/**
 * Service de stockage du token d'authentification sur le navigateur.
 */
@Injectable()
export class TokenStorage {
    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Déconnecte l'utilisateur.
     */
    signOut() {
        sessionStorage.clear();
    }

    /**
     * Enregistre le token d'authentification dans le SessionStorage.
     * @param token Instance du token d'authentification.
     */
    public saveToken(token: string) {
        sessionStorage.removeItem(TOKEN_KEY);
        sessionStorage.setItem(TOKEN_KEY, token);
    }

    /**
     * Retourne le token d'authentification à partir du SessionStorage.
     * @returns : Instance du token d'authentification.
     */
    public getToken(): string {
        return sessionStorage.getItem(TOKEN_KEY);
    }
}
